import React from 'react';

const Inventory = () => {
    return (
        <div>
            <h3>hello revel song of kazi nazrol islam</h3>
            <p>bolo bir,ami ciro onnto momo sir, sir nihari ami ri noto sir oi sikor himaddir.bolo vir ami ciro onnoto momo sir</p>
        </div>
    );
};

export default Inventory;